<template>
  <f7-app :params="f7params">
    <!--<FirstLogin v-if="isUserLoggedIn" />-->

    <ConsentGDPR v-if="!isLegalDocumentsPublicMode" />
    <div v-if="isHashRedirectLoading" class="hash-preloader-overlay">
      <div class="hash-preloader-card">
        <f7-preloader></f7-preloader>
        <div class="hash-preloader-text">
          {{ $t('loading') }}
        </div>
      </div>
    </div>
    <div
      v-if="
        isUserLoggedIn &&
        !isClientMenuReady &&
        !showTokenPage &&
        !showPrivacyPolicyPage
      "
      class="session-preloader-overlay"
    >
      <div class="hash-preloader-card">
        <f7-preloader></f7-preloader>
        <div class="hash-preloader-text">
          {{ $t('loading') }}
        </div>
      </div>
    </div>

    <!-- Ocultamos el panel lateral tras haber configurado el nuevo menú superior -->
    <!-- <LeftPanel
      v-if="
        isUserLoggedIn && !showTokenPage && !showPrivacyPolicyPage
      "
      :panel-options="options"
    /> -->
    <FilterPanel
      v-if="
        isUserLoggedIn &&
        isClientMenuReady &&
        !showTokenPage &&
        !showPrivacyPolicyPage
      "
    />
    <div
      v-if="isFilterPanelOpen"
      class="modal-backdrop"
      @click="closeRightPanel"
    ></div>
    <Navbar
      v-if="
        isUserLoggedIn && !showTokenPage && !showPrivacyPolicyPage
      "
      :socket="webSocket"
      @client-menu-ready="onClientMenuReady"
    />
    <Menu
      v-if="
        isUserLoggedIn &&
        isClientMenuReady &&
        !showTokenPage &&
        !showPrivacyPolicyPage
      "
      :menu-config="topMenuConfig"
    />
    <login-page
      v-if="
        showLogin &&
        !showTokenPage &&
        !showPrivacyPolicyPage &&
        !isLegalDocumentsPublicMode
      "
    />
    <password-recovery-page
      v-if="
        showPasswordRecovery &&
        !showTokenPage &&
        !showPrivacyPolicyPage &&
        !isLegalDocumentsPublicMode
      "
    />
    <f7-view
      v-if="
        isUserLoggedIn && isClientMenuReady && !showPrivacyPolicyPage
      "
      main
      class="safe-areas"
      url="/"
      :reload-pages="true"
    >
    </f7-view>

    <!-- <f7-view
      v-if="showTokenPage && !showPrivacyPolicyPage"
      main
      class="safe-areas"
      url="/token-recovery"
      :reload-pages="true"
    >
    </f7-view> -->
    <TokenRecoveryPage
      v-if="
        showTokenPage &&
        !showPrivacyPolicyPage &&
        !isLegalDocumentsPublicMode
      "
    />
    <f7-view
      v-if="showPrivacyPolicyPage"
      main
      class="safe-areas"
      url="/privacy-policy"
      :reload-pages="true"
    >
    </f7-view>
    <f7-view
      v-if="isLegalDocumentsPublicMode"
      main
      class="safe-areas legal-documents-public-view"
      :url="legalDocumentsPublicUrl"
      :reload-pages="true"
    >
    </f7-view>
  </f7-app>
</template>
<script>
import { mapActions, mapGetters, mapState } from 'vuex';
import LoginPage from '@/pages/login-page.vue';
import PasswordRecoveryPage from '@/pages/password-recovery-page.vue';
import Navbar from '@/components/Navbar/index.vue';
import Menu from '@/components/Menu/index.vue';
import FilterPanel from '@/components/FilterPanel/FilterPanel.vue';
import EventBus from '@/services/event-bus';
import MenuOptions from '@/json/menuOptions.json';
import ConsentGDPR from '@/components/PrivacyPolicy/ConsentGDPR.vue';
import {
  ALL_LANGUAGES,
  IS_LOCAL_TEST,
  NOTIFY_TIME_LONG,
  NOTIFICATION_WEBSOCKET_URL,
} from '@/js/constants';
import {
  getAllowedRoutesForUser,
  hasComplaintManagementAccess,
  hasComplaintRegisterAccess,
  hasContextualRouteAccess,
  isRouteAllowed,
  isPublicRoute,
  normalizeRouteKey,
} from '@/js/routeAccess';
import { resolveAtcKey } from '@/utils/atcRouting';
import { defaultLocale } from '@/i18n/index';
import { locale, loadMessages } from 'devextreme/localization';
import esMessages from '@/json/langs/es.json';
import itMessages from '@/json/langs/it.json';
import ptMessages from '@/json/langs/pt.json';
import enMessages from '@/json/langs/en.json';
import frMessages from '@/json/langs/fr.json';
import TokenRecoveryPage from '@/pages/Users/TokenRecoveryPage/index.vue';
import { getAppEntryUrl, getAppHashUrl } from '@/js/appEntryUrl';
import { startBundleVersionChecker } from '@/services/bundleVersionChecker';
import routes from '../js/routes';

const CLIENT_MENU_READY_TIMEOUT_MS = 15000;

function getInitialAppPath() {
  if (typeof window === 'undefined') return '/';

  if (window.location.hash.startsWith('#/')) {
    return window.location.hash.slice(1).split(/[?#]/)[0];
  }

  return window.location.pathname;
}

function getLegalDocumentsTargetPath(path = getInitialAppPath()) {
  return path === '/legal-notice'
    ? '/legal-notice'
    : '/legal-documents';
}

// Las rutas legales pueden llegar con query/hash para abrir un documento
// concreto. Separamos el path base para validar contra routes.js, pero
// conservamos el sufijo para navegar despues sin perder la seccion.
function splitRouteTarget(path = '/') {
  const [pathAndQuery, hash = ''] = String(path).split('#');
  const [routePath, query = ''] = pathAndQuery.split('?');
  const suffix = `${query ? `?${query}` : ''}${
    hash ? `#${hash}` : ''
  }`;

  return {
    routePath: routePath || '/',
    suffix,
  };
}

// La version publica y la version autenticada estan separadas a proposito:
// cargar la page publica dentro del router con sesion reintroduce bucles en
// navbar/menu. Si hay usuario, cualquier entrada publica se traduce aqui a
// su page interna equivalente.
function getAuthenticatedLegalRoutePath(path) {
  const normalizedPath = normalizeRouteKey(
    splitRouteTarget(path).routePath
  );

  if (normalizedPath === '/legal-notice') {
    return '/legal-notice-internal';
  }

  if (normalizedPath === '/legal-documents') {
    return '/legal-documents-internal';
  }

  return null;
}

export default {
  components: {
    LoginPage,
    Navbar,
    PasswordRecoveryPage,
    Menu,
    FilterPanel,
    ConsentGDPR,
    TokenRecoveryPage,
  },
  data() {
    return {
      // Framework7 Parameters
      f7params: {
        name: 'Besafer 4.0', // App name
        theme: 'aurora',
        // App routes
        routes,
        pushState: true,
        preloadPreviousPage: false,

        preloader: {
          hideOnPageLoad: false,
        },
        dialog: {
          buttonCancel: this.$t('cancel'),
        },
      },
      langsDx: {
        esMessages,
        frMessages,
        ptMessages,
        enMessages,
        itMessages,
      },
      shouldNotify: false,
      interval: null,
      canContinue: true,
      // Evita mostrar el dashboard hasta que ClientMenu confirme que sus
      // opciones y la compañía activa ya están disponibles.
      isClientMenuReady: false,
      clientMenuReadyTimeoutId: null,
      webSocket: null,
      notificationWebSocketUrl: null,
      isFilterPanelOpen: false,
      isHashRedirectLoading: false,
      bundleReloadStarted: false,
      bundleVersionCheckerStop: null,
      isLegalDocumentsPublicMode:
        isPublicRoute(getInitialAppPath()) &&
        !this.$store?.state?.user?.isUserLoggedIn,
      legalDocumentsPublicUrl: getLegalDocumentsTargetPath(),
      MenuOptions,
    };
  },
  computed: {
    topMenuConfig() {
      const cfg = JSON.parse(JSON.stringify(MenuOptions));

      if (cfg?.home?.items) {
        // El top menu solo pinta items que el usuario puede navegar de verdad.
        // Asi evitamos tener reglas duplicadas entre "lo muestro" y "lo permito".
        cfg.home.items = cfg.home.items.filter((item) =>
          this.hasAccessToRoute(item?.url)
        );
      }

      // La lógica de "farm" en el panel eliminaba SOLO el submenú interno
      // de "/agronomy/advanced-services". En el top-menu no mostramos esos
      // sub-submenús, así que NO hace falta tocar nada aquí para farm.
      // (Si en el futuro quieres ocultar pestañas por farm/cliente,
      // se filtran aquí del mismo modo.)

      return cfg;
    },
    showLogin() {
      return !this.isUserLoggedIn && !this.isUserRecoveringPassword;
    },
    showPasswordRecovery() {
      return !this.isUserLoggedIn && this.isUserRecoveringPassword;
    },
    showPrivacyPolicyPage() {
      return this.showPrivacyPolicy;
    },
    // En este proyecto seguimos usando `enabled` para distinguir
    // contactos de empleados AGQ.
    isEmployee() {
      return !this.enabled;
    },
    isContact() {
      return !!this.enabled;
    },
    // Este listado es la "fuente de verdad" para decidir si una ruta
    // forma parte del espacio navegable del usuario actual.
    // Luego, en hasAccessToRoute, se completa con reglas dinamicas
    // que ya existian para servicios avanzados o analytics.
    allowedRoutesForCurrentUser() {
      return getAllowedRoutesForUser({
        isEmployee: this.isEmployee,
        isContact: this.isContact,
        isAdmin: this.isAdmin,
        canAccessMaterialRequest: this.showMaterialRequest(),
        canAccessComplaints: this.canAccessComplaints,
        canAccessComplaintRegister: this.canRegisterComplaints,
      });
    },
    canAccessComplaints() {
      return hasComplaintManagementAccess({
        enabled: this.enabled,
        authenticatedUser: this.authenticatedUser,
        company: this.company,
      });
    },
    canRegisterComplaints() {
      return hasComplaintRegisterAccess({
        enabled: this.enabled,
        authenticatedUser: this.authenticatedUser,
        company: this.company,
      });
    },
    ...mapGetters('user', ['userProfile', 'isAdmin']),
    ...mapGetters('contact', ['contactInfo']),
    ...mapState('registerFarm', ['farm']),
    ...mapState('clientMenu', ['items']),
    ...mapState('contact', [
      'enabled',
      'company',
      'hasAccessToAdvanceService',
      'hasAccessToNutritionalMonitoring',
    ]),
    ...mapState('PowerBiModules', ['availableCountries']),
    ...mapState('user', [
      'isUserLoggedIn',
      'accessToken',
      'isUserRecoveringPassword',
      'authenticatedUser',
      'languageInterface',
      'showTokenPage',
      'showPrivacyPolicy',
    ]),
  },
  watch: {
    // Revalidamos la pantalla activa cuando cambia el contexto del selector
    // superior para no dejar abierta una vista que ya no corresponde.
    company() {
      this.enforceCurrentRouteAccess();
    },
    availableCountries: {
      deep: true,
      handler() {
        this.enforceCurrentRouteAccess();
      },
    },
    hasAccessToAdvanceService() {
      this.enforceCurrentRouteAccess();
    },
    hasAccessToNutritionalMonitoring() {
      this.enforceCurrentRouteAccess();
    },
    isUserLoggedIn(value) {
      if (!value) {
        this.cancelClientMenuReadyTimeout();
        this.isClientMenuReady = false;
      } else {
        this.startClientMenuReadyTimeout();
      }
      this.$nextTick(this.syncLegalDocumentsFooterLink);
    },
    showTokenPage() {
      this.$nextTick(this.syncLegalDocumentsFooterLink);
    },
    showPrivacyPolicyPage() {
      this.$nextTick(this.syncLegalDocumentsFooterLink);
    },
    languageInterface() {
      this.$nextTick(this.syncLegalDocumentsFooterLink);
    },
  },
  created() {
    this.lastTrackedPagePath = null;
    this.legalDocumentsFooterElement = null;
    this.legalDocumentsFooterLink = null;
    this.legalDocumentsFooterClickHandler = null;
    this.legalDocumentsFooterRetryTimeout = null;
    this.legalDocumentsFooterObserver = null;
    this.legalDocumentsFooterObservedPageContent = null;
  },
  beforeMount() {
    if (this.isLegalDocumentsPublicMode) {
      return;
    }

    const token = this.getQueryParam('token');
    if (token) {
      setTimeout(() => {
        this.logOut();
        this.closeNotificationWebSocket();
      }, 0);
      this.setShowTokenPage(true);

      this.canContinue = false;
    }
  },
  async mounted() {
    // La SPA puede permanecer abierta durante varios días y seguir ejecutando
    // el bundle antiguo. El servicio compara periódicamente su hash con el
    // hash publicado en index.html para detectar nuevos despliegues.
    this.bundleVersionCheckerStop = startBundleVersionChecker({
      entryUrl: getAppEntryUrl(),
      onNewBundle: () => {
        if (this.bundleReloadStarted) return;

        this.bundleReloadStarted = true;
        // Fuerza una nueva petición de la entrada HTML incluso si el
        // navegador aún conserva index.html en su caché HTTP. Se mantiene la
        // URL actual para que Framework7 pueda recuperar la pantalla activa.
        const reloadUrl = new URL(window.location.href);
        reloadUrl.searchParams.set(
          '__bundle_reload',
          String(Date.now())
        );
        window.location.replace(reloadUrl.toString());
      },
    });

    this.$f7.on('pageAfterIn', this.trackPageView);

    if (this.isLegalDocumentsPublicMode) {
      this.$f7ready(() => {
        this.$f7.preloader.hide();
      });
      return;
    }

    if (this.isUserLoggedIn && this.authenticatedUser) {
      this.startClientMenuReadyTimeout();
      this.createMenuStructure();
    }

    this.$f7ready(() => {
      this.$nextTick(() => {
        if (this.isClientMenuReady) {
          this.tryRedirectFromHash();
        }
        this.syncLegalDocumentsFooterLink();
      });
    });
    // Cargamos paises disponibles lo antes posible para que una URL directa
    // a My Smart Analytics pase por la misma validacion que el menu.
    this.fetchCountriesAvailables().catch((error) => {
      console.warn(
        'Unable to preload available countries on app startup',
        error
      );
    });
    this.$f7.on('panelOpen', (panelInstance) => {
      if (panelInstance.side === 'right') {
        this.isFilterPanelOpen = true;
      }
    });
    this.$f7.on('panelClose', (panelInstance) => {
      if (panelInstance.side === 'right') {
        this.isFilterPanelOpen = false;
      }
    });
    this.$f7.on('pageAfterIn', this.syncLegalDocumentsFooterLink);
    EventBus.$on('newLoggedUser', () => {
      this.setActiveUserEmail(this.authenticatedUser?.email || null);
      this.setContactIndex(0);
      this.isClientMenuReady = false;
      this.startClientMenuReadyTimeout();
      this.createMenuStructure();
    });
    if (this.isUserLoggedIn && this.authenticatedUser?.email) {
      this.setActiveUserEmail(this.authenticatedUser.email);
    }
    this.setPendingNotifications(false);
    this.setPreferedLanguage();
    EventBus.$off('onChangeCompany');
    EventBus.$on('onChangeCompany', this.busListener);
    EventBus.$on('tokenRefreshed', this.realoadPage);
    // this.setShowTokenPage(true);
    const token = this.getQueryParam('token');
    if (!token) {
      this.canContinue = true;
    }
    if (!this.canContinue) return;
    this.setShowTokenPage(false);
  },
  beforeDestroy() {
    this.bundleVersionCheckerStop?.();
    this.cancelClientMenuReadyTimeout();
    this.$f7?.off('pageAfterIn', this.trackPageView);
    this.$f7?.off('pageAfterIn', this.syncLegalDocumentsFooterLink);
    window.clearTimeout(this.legalDocumentsFooterRetryTimeout);
    window.removeEventListener(
      'resize',
      this.updateObservedLegalDocumentsFooterPlacement
    );
    this.removeLegalDocumentsFooterLink();
  },
  async beforeUpdate() {
    if (this.isLegalDocumentsPublicMode) return;

    if (!this.isUserLoggedIn) return;
    const token = this.getQueryParam('token');
    if (token) {
      this.setIsUserLoggedIn(false);
      setTimeout(() => {
        this.logOut();
        this.closeNotificationWebSocket();
        // this.setPreferedLanguage();
      }, 0);
      this.setShowTokenPage(true);
      return;
    }
    if (this.enabled) {
      this.setPendingNotifications(false);
    }
  },
  methods: {
    trackPageView(page) {
      const route = page?.route || {};
      const pagePath = route.url || route.path || page?.url || '/';

      if (pagePath === this.lastTrackedPagePath) return;

      this.lastTrackedPagePath = pagePath;
      if (IS_LOCAL_TEST || typeof window === 'undefined') return;
      window.gtag?.('event', 'page_view', {
        page_title: route.name || page?.name || document.title,
        page_path: pagePath,
      });
    },
    onClientMenuReady() {
      if (
        this.isClientMenuReady ||
        !Array.isArray(this.items) ||
        this.items.length === 0
      ) {
        return;
      }

      this.isClientMenuReady = true;
      this.cancelClientMenuReadyTimeout();
      this.$f7ready(() => {
        this.$nextTick(() => {
          // La vista principal solo se monta después de que el selector
          // confirme que la compañía accesible está lista.
          this.tryRedirectFromHash();
          this.syncLegalDocumentsFooterLink();
        });
      });
    },
    startClientMenuReadyTimeout() {
      this.cancelClientMenuReadyTimeout();

      if (!this.isUserLoggedIn || this.isClientMenuReady) {
        return;
      }

      this.clientMenuReadyTimeoutId = window.setTimeout(() => {
        this.clientMenuReadyTimeoutId = null;

        if (!this.isUserLoggedIn || this.isClientMenuReady) {
          return;
        }

        this.closeNotificationWebSocket();
        this.logOut();
        this.$notifyDX(
          {
            message: this.$t('accessNotAvailable'),
            width: 450,
          },
          'error',
          NOTIFY_TIME_LONG
        );
      }, CLIENT_MENU_READY_TIMEOUT_MS);
    },
    cancelClientMenuReadyTimeout() {
      if (this.clientMenuReadyTimeoutId !== null) {
        window.clearTimeout(this.clientMenuReadyTimeoutId);
        this.clientMenuReadyTimeoutId = null;
      }
    },
    shouldShowLegalDocumentsFooterLink() {
      return (
        this.isUserLoggedIn &&
        !this.showTokenPage &&
        !this.showPrivacyPolicyPage
      );
    },
    getActivePageContent() {
      const currentPage =
        this.$f7?.views?.main?.router?.currentPageEl;

      return (
        currentPage?.querySelector?.('.page-content') ||
        document.querySelector(
          '.view-main .page-current .page-content'
        )
      );
    },
    isVisibleElement(element) {
      if (!element) return false;

      const style = window.getComputedStyle(element);

      return (
        style.display !== 'none' &&
        style.visibility !== 'hidden' &&
        style.opacity !== '0' &&
        !!(
          element.offsetWidth ||
          element.offsetHeight ||
          element.getClientRects().length
        )
      );
    },
    isPageContentLoading(pageContent) {
      if (!pageContent) return false;

      const visiblePreloader = Array.from(
        pageContent.querySelectorAll(
          '.preloader-overlay, .preloader-center'
        )
      ).some((element) => this.isVisibleElement(element));

      if (!visiblePreloader) return false;

      // Algunas tablas tienen preloaders internos mientras DevExtreme termina
      // de pintar la grid. Si la pagina ya tiene contenido visible, no
      // bloqueamos el footer legal por un loader secundario.
      const hasVisiblePageContent = Array.from(
        pageContent.children
      ).some(
        (element) =>
          element !== this.legalDocumentsFooterElement &&
          !element.matches('.preloader-overlay, .preloader-center') &&
          this.isVisibleElement(element)
      );

      return !hasVisiblePageContent;
    },
    scheduleLegalDocumentsFooterSync() {
      window.clearTimeout(this.legalDocumentsFooterRetryTimeout);
      this.legalDocumentsFooterRetryTimeout = window.setTimeout(
        () => {
          this.syncLegalDocumentsFooterLink();
        },
        400
      );
    },
    ensureLegalDocumentsFooterElement() {
      if (this.legalDocumentsFooterElement) {
        return;
      }

      this.legalDocumentsFooterElement =
        document.createElement('div');
      this.legalDocumentsFooterElement.className =
        'legal-documents-auth-footer';

      this.legalDocumentsFooterLink = document.createElement('a');
      this.legalDocumentsFooterLink.className =
        'legal-documents-auth-footer__link';
      this.legalDocumentsFooterLink.href =
        '/legal-documents-internal';

      this.legalDocumentsFooterClickHandler = (event) => {
        event.preventDefault();
        this.openInternalLegalDocuments();
      };
      this.legalDocumentsFooterLink.addEventListener(
        'click',
        this.legalDocumentsFooterClickHandler
      );

      this.legalDocumentsFooterElement.appendChild(
        this.legalDocumentsFooterLink
      );
    },
    removeLegalDocumentsFooterLink() {
      if (
        this.legalDocumentsFooterLink &&
        this.legalDocumentsFooterClickHandler
      ) {
        this.legalDocumentsFooterLink.removeEventListener(
          'click',
          this.legalDocumentsFooterClickHandler
        );
      }

      this.legalDocumentsFooterElement?.parentNode?.removeChild(
        this.legalDocumentsFooterElement
      );
      document
        .querySelectorAll('.legal-documents-auth-footer-host')
        .forEach((element) => {
          element.classList.remove(
            'legal-documents-auth-footer-host'
          );
        });
      window.clearTimeout(this.legalDocumentsFooterRetryTimeout);
      this.legalDocumentsFooterElement = null;
      this.legalDocumentsFooterLink = null;
      this.legalDocumentsFooterClickHandler = null;
      this.legalDocumentsFooterRetryTimeout = null;
      this.legalDocumentsFooterObserver?.disconnect();
      this.legalDocumentsFooterObserver = null;
      this.legalDocumentsFooterObservedPageContent = null;
    },
    observeLegalDocumentsFooterHost(pageContent) {
      if (
        this.legalDocumentsFooterObservedPageContent === pageContent
      ) {
        return;
      }

      this.legalDocumentsFooterObserver?.disconnect();
      window.removeEventListener(
        'resize',
        this.updateObservedLegalDocumentsFooterPlacement
      );

      this.legalDocumentsFooterObservedPageContent = pageContent;

      if (window.MutationObserver) {
        this.legalDocumentsFooterObserver = new MutationObserver(
          this.updateObservedLegalDocumentsFooterPlacement
        );
        this.legalDocumentsFooterObserver.observe(pageContent, {
          childList: true,
          subtree: true,
        });
      }

      window.addEventListener(
        'resize',
        this.updateObservedLegalDocumentsFooterPlacement
      );
    },
    updateObservedLegalDocumentsFooterPlacement() {
      window.clearTimeout(this.legalDocumentsFooterRetryTimeout);
      this.legalDocumentsFooterRetryTimeout = window.setTimeout(
        () => {
          this.updateLegalDocumentsFooterPlacement(
            this.legalDocumentsFooterObservedPageContent
          );
        },
        100
      );
    },
    updateLegalDocumentsFooterPlacement(pageContent) {
      if (!this.legalDocumentsFooterElement || !pageContent) {
        return;
      }

      document
        .querySelectorAll('.legal-documents-auth-footer-host')
        .forEach((element) => {
          element.classList.remove(
            'legal-documents-auth-footer-host'
          );
        });
      this.legalDocumentsFooterElement.removeAttribute('style');
      this.legalDocumentsFooterElement.classList.remove(
        'legal-documents-auth-footer--bottom'
      );

      window.requestAnimationFrame(() => {
        const footerBottom =
          this.legalDocumentsFooterElement.offsetTop +
          this.legalDocumentsFooterElement.offsetHeight;
        const hasScroll =
          pageContent.scrollHeight > pageContent.clientHeight + 1;

        if (
          !hasScroll &&
          footerBottom < pageContent.clientHeight - 20
        ) {
          pageContent.classList.add(
            'legal-documents-auth-footer-host'
          );
          this.legalDocumentsFooterElement.classList.add(
            'legal-documents-auth-footer--bottom'
          );
        }
      });
    },
    syncLegalDocumentsFooterLink() {
      if (
        this.isLegalDocumentsPublicMode ||
        !this.shouldShowLegalDocumentsFooterLink()
      ) {
        this.removeLegalDocumentsFooterLink();
        return;
      }

      const pageContent = this.getActivePageContent();
      if (!pageContent) {
        this.removeLegalDocumentsFooterLink();
        return;
      }

      // Algunas paginas, como Dashboard, montan primero un preloader propio y
      // despues sustituyen el contenido. Esperamos a que desaparezca para que
      // el footer no asome arriba durante la carga.
      if (this.isPageContentLoading(pageContent)) {
        this.legalDocumentsFooterElement?.parentNode?.removeChild(
          this.legalDocumentsFooterElement
        );
        this.scheduleLegalDocumentsFooterSync();
        return;
      }

      this.ensureLegalDocumentsFooterElement();
      this.legalDocumentsFooterLink.textContent = this.$t(
        'legalDocumentation'
      );

      // Se inserta dentro del scroll real de Framework7. Asi se comporta como
      // footer de cada pagina y no tapa tablas, filtros ni contenido flotante.
      if (
        this.legalDocumentsFooterElement.parentNode !== pageContent
      ) {
        pageContent.appendChild(this.legalDocumentsFooterElement);
      }

      this.observeLegalDocumentsFooterHost(pageContent);
      this.updateLegalDocumentsFooterPlacement(pageContent);
    },
    openInternalLegalDocuments() {
      this.$f7ready(() => {
        const router = this.$f7?.views?.main?.router;

        if (router) {
          // Sin section/query: el acceso fijo debe abrir siempre el inicio
          // de la documentacion, aunque antes se visitara un documento concreto.
          router.navigate('/legal-documents-internal', {
            animate: true,
            transition: 'f7-fade',
            reloadCurrent: true,
          });
          return;
        }

        window.location.assign(
          getAppHashUrl('/legal-documents-internal')
        );
      });
    },
    wait(ms) {
      return new Promise((resolve) => setTimeout(resolve, ms));
    },
    async ensureClientMenuReady() {
      if (!this.isUserLoggedIn) {
        return;
      }

      if (!Array.isArray(this.items) || this.items.length === 0) {
        this.createMenuStructure();
      }

      let attempts = 0;
      while (
        attempts < 20 &&
        (!Array.isArray(this.items) || this.items.length === 0)
      ) {
        attempts += 1;
        await this.wait(100);
      }
    },
    getAppRouteMap() {
      const map = new Map();

      routes.forEach((route) => {
        const path = route?.path;
        if (!path || path === '(.*)') return;
        map.set(normalizeRouteKey(path), path);
      });

      return map;
    },
    closeRightPanel() {
      // Llama al método de F7 para cerrar el panel derecho sin animación
      // Esto cerrará el panel desde el backdrop
      this.$f7.panel.close('right', false);
    },
    hasAccessToRoute(path) {
      const normalizedPath = normalizeRouteKey(path);

      if (isPublicRoute(normalizedPath)) {
        return false;
      }

      // Primer filtro: pertenece al set de rutas permitidas para el tipo
      // de usuario actual (empleado, contacto admin, contacto no admin...).
      const hasRouteInUserScope = isRouteAllowed(
        normalizedPath,
        this.allowedRoutesForCurrentUser
      );

      if (!hasRouteInUserScope) {
        return false;
      }

      // Segundo filtro: mantenemos las validaciones dinamicas que ya tenia
      // la interfaz en otros puntos, para no abrir por URL algo que el
      // submenu o el menu lateral ya estaban ocultando.
      return hasContextualRouteAccess(normalizedPath, {
        enabled: this.enabled,
        hasAccessToAdvanceService: this.hasAccessToAdvanceService,
        hasAccessToNutritionalMonitoring:
          this.hasAccessToNutritionalMonitoring,
        availableCountries: this.availableCountries,
        company: this.company,
      });
    },
    enforceCurrentRouteAccess() {
      if (!this.isUserLoggedIn || this.showPrivacyPolicyPage) {
        return;
      }

      const currentPath =
        this.$f7?.views?.main?.router?.currentRoute?.path;

      if (!currentPath) {
        return;
      }

      const normalizedPath = normalizeRouteKey(currentPath);

      if (
        normalizedPath === '/' ||
        this.hasAccessToRoute(normalizedPath)
      ) {
        return;
      }

      // Si la nueva compañía pierde acceso a la ruta actual, volvemos al
      // dashboard en vez de mantener una pantalla incoherente.
      this.$f7?.views?.main?.router?.navigate('/', {
        animate: true,
        transition: 'f7-fade',
        reloadCurrent: true,
      });
    },
    showMaterialRequest() {
      // const companyPrefix = this.company?.substring(0, 2) || '';
      // const availablesOn = ['ES'];

      // return availablesOn.includes(companyPrefix);

      const availableCompanies = [
        'ES20-00033056',
        'ES20-00031624',
        'ES20-00032357',
      ];

      return availableCompanies.includes(this.company);
    },
    // Extrae la intencion de redireccion del hash o ruta directa.
    // Formatos soportados:
    // - "#/sample_code/AL/24-019231032"
    // - "#/sample_code/AL%2F24-019231032"
    // - "#/ComplaintManagement/"
    // - "/profile" (ruta directa sin hash)
    getHashRedirectPayload() {
      const { hash, pathname } = window.location;

      // Si llega con hash, mantenemos el formato historico `/#/ruta`
      // y resolvemos la intencion exactamente igual que antes.
      if (hash.startsWith('#/')) {
        const rawRoute = hash.slice(2);
        if (!rawRoute) return null;

        const sampleCodeMarker = 'sample_code/';

        // sample_code solo es valido si va justo tras "#/".
        if (rawRoute.startsWith(sampleCodeMarker)) {
          const sampleCodeRaw = rawRoute.slice(
            sampleCodeMarker.length
          );
          let sampleCode = sampleCodeRaw;
          try {
            sampleCode = decodeURIComponent(sampleCodeRaw);
          } catch (error) {
            sampleCode = sampleCodeRaw;
          }

          return {
            type: 'sample_code',
            sampleCode: sampleCode?.trim() || null,
          };
        }

        // Si sample_code aparece en otra posicion, lo consideramos invalido.
        if (rawRoute.includes(sampleCodeMarker)) {
          return { type: 'invalid' };
        }

        const matched = rawRoute ? `/${rawRoute}` : '/';

        return {
          type: 'section',
          matched,
          usesHash: true,
        };
      }

      // Si entra sin hash pero con pathname, lo tratamos igual que una
      // navegacion directa normal. La validacion real se hace despues.
      if (pathname && pathname !== '/') {
        const documentHash =
          hash && !hash.startsWith('#/') ? hash : '';

        return {
          type: 'section',
          matched: `${pathname}${documentHash}`,
          usesHash: false,
        };
      }

      // No hay hash ni ruta directa
      return null;
    },
    isKnownRoute(path) {
      const normalizedPath = normalizeRouteKey(path);
      return this.getAppRouteMap().has(normalizedPath);
    },
    cleanUrlHash() {
      const cleanUrl =
        window.location.pathname + window.location.search;
      window.history.replaceState(null, document.title, cleanUrl);
    },
    navigateToHomeAndCleanHash(router) {
      const targetRouter = router || this.$f7.views.main.router;

      try {
        targetRouter.navigate('/', {
          animate: true,
          transition: 'f7-fade',
          reloadCurrent: true,
          clearPreviousHistory: true,
        });
      } catch (error) {
        window.location.href = getAppEntryUrl();
      }

      this.$f7.once('pageAfterIn', (page) => {
        if (page.route.path === '/') {
          this.cleanUrlHash();
        }
      });
    },
    navigateToRouteWithHash(routePath) {
      const target = splitRouteTarget(routePath);
      const cleanPath = normalizeRouteKey(target.routePath);
      const targetUrl = getAppHashUrl(`${cleanPath}${target.suffix}`);

      window.location.replace(targetUrl);
    },
    async tryRedirectFromHash() {
      if (!this.isUserLoggedIn) {
        return;
      }

      const payload = this.getHashRedirectPayload();
      if (!payload) {
        return;
      }

      const mainView = this.$f7.views.find(
        (v) => v.router?.view?.params?.url === '/'
      );

      const router = mainView?.router;
      if (!router) {
        return;
      }

      if (payload.type === 'invalid') {
        this.navigateToHomeAndCleanHash(router);
        return;
      }

      if (payload.type === 'sample_code') {
        if (!payload.sampleCode) {
          this.navigateToHomeAndCleanHash(router);
          return;
        }

        this.isHashRedirectLoading = true;
        try {
          const canNavigate = await this.redirectToSampleDetailByCode(
            payload.sampleCode
          );

          if (canNavigate) {
            this.cleanUrlHash();
          } else {
            // Si falla API o no hay acceso a la seccion de esa muestra, inicio.
            this.navigateToHomeAndCleanHash(router);
          }
        } finally {
          // Ocultamos al terminar la navegación (o si falló y volvió al inicio).
          this.$f7.once('pageAfterIn', () => {
            this.isHashRedirectLoading = false;
          });
          setTimeout(() => {
            this.isHashRedirectLoading = false;
          }, 3000);
        }
        return;
      }

      const { matched, usesHash = true } = payload;
      const target = splitRouteTarget(matched);
      const routePath =
        getAuthenticatedLegalRoutePath(target.routePath) ||
        target.routePath;
      const normalizedPath = normalizeRouteKey(routePath);
      const resolvedRoutePath =
        this.getAppRouteMap().get(normalizedPath);
      const resolvedRouteUrl = resolvedRoutePath
        ? `${resolvedRoutePath}${target.suffix}`
        : null;
      const isKnownRoute = !!resolvedRoutePath;
      const hasAccess = this.hasAccessToRoute(normalizedPath);
      const shouldRewriteWithoutHash =
        !usesHash && isKnownRoute && hasAccess;

      if (shouldRewriteWithoutHash) {
        // Si la entrada venia sin hash, la normalizamos al formato habitual
        // de la app antes de continuar. Asi evitamos casos en los que
        // Framework7 deja la vista en blanco aunque la ruta sea valida.
        this.navigateToRouteWithHash(resolvedRouteUrl);
        return;
      }

      // Si la ruta no existe o no le corresponde a este usuario,
      // limpiamos la URL y lo devolvemos al home.
      if (!isKnownRoute || !hasAccess) {
        this.navigateToHomeAndCleanHash(router);
        return;
      }

      // Usar el método directo de Framework7 para navegar
      try {
        this.$f7.views.main.router.navigate(resolvedRouteUrl, {
          animate: true,
          transition: 'f7-fade',
          reloadCurrent: true,
        });
      } catch (error) {
        // Si falla, intentar usando window.location como fallback
        window.location.hash = `#${resolvedRouteUrl}`;
      }

      this.$f7.once('pageAfterIn', (page) => {
        const expected = resolvedRoutePath;
        if (page.route.path === expected) {
          this.cleanUrlHash();
        }
      });
    },
    async redirectToSampleDetailByCode(sampleCode) {
      try {
        await this.ensureClientMenuReady();
        this.setSampleFetchedFromEtl(false);
        this.setLastRouteHome(false);
        this.setLastRouteGeotoolboxSamples(false);
        this.setLastRouteIssuedInvoicesList(true);

        this.setReportSampleCode(sampleCode);

        const { sample: currentSample, matchedItem } =
          await this.getAccessibleSampleByCode();
        const currentSampleId =
          this.getSampleInternalId(currentSample);

        if (!currentSampleId) {
          return false;
        }

        // La muestra puede pertenecer a un cliente distinto del que estaba
        // seleccionado. Reajustamos el selector antes de abrir el detalle.
        const scopeSynced =
          this.syncClientScopeFromSample(currentSample) ||
          this.applyMatchedScopeItem(matchedItem);
        if (!scopeSynced) return false;

        this.setCurrentSampleId(currentSampleId);

        const canNavigate = await this.goToSampleDetailsByAtc(
          currentSample?.atc_name,
          currentSample
        );
        return !!canNavigate;
      } catch (error) {
        return false;
      }
    },
    getSampleInternalId(sample) {
      // En distintos flujos la API puede devolver Mongo `_id`
      // o `sample_id` además de `id`.
      // En distintos flujos la API puede devolver Mongo `_id`.
      return sample?.id || sample?._id || sample?.sample_id || null;
    },
    getSampleScopeFromResponse(sample) {
      return {
        // Contrato actual del backend.
        companyCode: sample?.company_code || null,
        companyName: sample?.company || null,
        addressCode: sample?.address_code || null,
      };
    },
    getCurrentScopeKey() {
      return [this.company, this.address]
        .map((value) => String(value ?? '').trim())
        .join('||');
    },
    getScopeKey(scope) {
      return [scope?.companyCode, scope?.addressCode]
        .map((value) => String(value ?? '').trim())
        .join('||');
    },
    getRequestScopeFromItem(item) {
      if (!item) return null;

      return this.enabled
        ? {
            companyCode: item.addressCompany,
            addressCode: item.addressCode,
          }
        : {
            companyCode: item.companyCode,
            addressCode: item.addressCode,
          };
    },
    getAllowedScopeItems() {
      const normalizedItems = Array.isArray(this.items)
        ? this.items.filter(Boolean)
        : [];

      if (normalizedItems.length === 0) {
        return [];
      }

      const currentScopeKey = this.getCurrentScopeKey();
      const uniqueItems = [];
      const seen = new Set();

      normalizedItems.forEach((item) => {
        const scope = this.getRequestScopeFromItem(item);
        const scopeKey = this.getScopeKey(scope);
        const hasRequiredScope =
          scope?.companyCode && scope?.addressCode;

        if (!hasRequiredScope || seen.has(scopeKey)) {
          return;
        }

        seen.add(scopeKey);
        uniqueItems.push(item);
      });

      uniqueItems.sort((left, right) => {
        const leftKey = this.getScopeKey(
          this.getRequestScopeFromItem(left)
        );
        const rightKey = this.getScopeKey(
          this.getRequestScopeFromItem(right)
        );

        if (leftKey === currentScopeKey) return -1;
        if (rightKey === currentScopeKey) return 1;
        return 0;
      });

      return uniqueItems;
    },
    applyMatchedScopeItem(item) {
      if (!item) return false;

      this.applyClientScopeItem(item);
      return true;
    },
    async getAccessibleSampleByCode() {
      const scopeItems = this.getAllowedScopeItems();

      if (scopeItems.length === 0) {
        const sample = await this.getCurrentSampleByCode();
        return { sample, matchedItem: null };
      }

      for (const item of scopeItems) {
        try {
          const scope = this.getRequestScopeFromItem(item);
          const sample = await this.getCurrentSampleByCode(scope);

          if (this.getSampleInternalId(sample)) {
            return { sample, matchedItem: item };
          }
        } catch (error) {
          // Seguimos probando el resto de alcances accesibles.
        }
      }

      return { sample: null, matchedItem: null };
    },
    applyClientScopeItem(matchedItem) {
      if (this.enabled) {
        // Mismo orden que en inicialización/cambio de selector.
        this.setAddress(matchedItem.addressCode);
        this.setCompany(matchedItem.addressCompany);
        this.setAddressName(matchedItem.name);
        this.setCompanyName(matchedItem.companyName);
        this.setCurrency(matchedItem.currency || null);

        if (matchedItem.contactIndex != null) {
          this.setContactIndex(matchedItem.contactIndex);
        }
        if (Array.isArray(matchedItem.itemsData)) {
          this.setAddresses(matchedItem.itemsData);
        }
      } else {
        this.setAddress(matchedItem.addressCode);
        this.setAddressName(matchedItem.addressName);
        this.setCompany(matchedItem.companyCode);
        this.setCompanyName(matchedItem.companyName);
        this.setCurrency(matchedItem.currency || null);
      }

      this.setMenuAddress();
    },
    syncClientScopeFromSample(sample) {
      const scope = this.getSampleScopeFromResponse(sample);
      if (!scope.companyCode) return false;

      if (this.enabled) {
        // Modo contacto: match exacto por company + address.
        const matchedItem = this.items.find(
          (item) =>
            item.addressCompany === scope.companyCode &&
            item.addressCode === scope.addressCode
        );
        if (!matchedItem) return false;
        this.applyClientScopeItem(matchedItem);
      } else {
        // Modo AGQ: intentamos sincronizar el selector si ya estÃ¡ cargado,
        // pero no bloqueamos la apertura del detalle si la muestra ya fue
        // recuperada correctamente por cÃ³digo.
        if (!Array.isArray(this.items) || this.items.length === 0) {
          return false;
        }

        // Modo AGQ: selector por company.
        const matchedItem = this.items.find(
          (item) => item.companyCode === scope.companyCode
        );
        if (!matchedItem) return false;
        this.applyClientScopeItem(matchedItem);
      }
      return true;
    },
    async goToSampleDetailsByAtc(atcName, sample) {
      const atcKey = resolveAtcKey({
        atc_name: sample?.atc_name || atcName,
        atc_code: sample?.atc_code,
      });

      const navigateToSampleDetail = (
        sectionName,
        sectionPage,
        detailPage
      ) => {
        this.clearRoutes();
        this.pushRoute({
          name: sectionName,
          disabled: false,
          page: sectionPage,
          active: false,
        });
        this.pushRoute({
          name: this.$t('sampleSummary'),
          disabled: true,
          page: detailPage,
          active: true,
        });
        this.$f7.views.main.router.navigate(
          { name: detailPage },
          {
            animate: true,
            transition: 'f7-fade',
          }
        );
        return true;
      };

      if (atcKey === 'FOOD') {
        this.setCurrentFilter('foodDetails');
        this.setIsNoRp(sample.value_report === 'CMA');
        this.setSelectedLimits([this.$t('positives')]);

        if (sample.value_report !== 'CMA') {
          if (sample.retailers) {
            const chains = [...sample.retailers];
            const res = [];
            chains.forEach((chainData) => {
              chainData.Reglas.forEach((chain) => {
                if (
                  res.length > 0 &&
                  res.some(
                    (el) => el.Supermercado === chainData.Supermercado
                  )
                ) {
                  const indexRes = res.findIndex(
                    (el) => el.Supermercado === chainData.Supermercado
                  );
                  res[indexRes] = {
                    ...res[indexRes],
                    [`Regla ${chain.Regla}`]: chain.Regla,
                    [`Resultado ${chain.Regla}`]: chain.Resultado,
                    [`CodRegla ${chain.Regla}`]: chain.CodRegla,
                    Supermercado: chainData.Supermercado,
                    Confirmado: chainData.Confirmado,
                  };
                } else {
                  res.push({
                    [`Resultado ${chain.Regla}`]: chain.Resultado,
                    [`Regla ${chain.Regla}`]: chain.Regla,
                    [`CodRegla ${chain.Regla}`]: chain.CodRegla,
                    Supermercado: chainData.Supermercado,
                    Confirmado: chainData.Confirmado,
                    ...chain,
                  });
                }
              });
            });
            this.setEuropeanChains(res);
          } else {
            this.setEuropeanChains([]);
          }
        }

        return navigateToSampleDetail(
          this.$t('Food'),
          'FoodSamplesPage',
          'FoodSampleDetailPage'
        );
      }
      if (atcKey === 'AGRONOMY') {
        this.setCurrentFilter('agronomy');
        return navigateToSampleDetail(
          this.$t('Agronomy'),
          'AgronomySamplesPage',
          'AgronomySamplesDetailsPage'
        );
      }
      if (atcKey === 'ENVIRONMENT') {
        this.setCurrentFilter('environmentDetails');
        return navigateToSampleDetail(
          this.$t('Environment'),
          'EnvironmentSamplesPage',
          'EnvironmentSamplesDetailsPage'
        );
      }
      if (atcKey === 'MINING') {
        this.setCurrentFilter('miningDetails');
        return navigateToSampleDetail(
          this.$t('Mining'),
          'MiningSamplesPage',
          'MiningSamplesDetailsPage'
        );
      }
      if (atcKey === 'HEALTH_SECURITY') {
        this.setCurrentFilter('healthSecurityDetails');
        return navigateToSampleDetail(
          this.$t('Health and Security'),
          'HealthSecuritySamplesPage',
          'HealthSecuritySamplesDetailsPage'
        );
      }

      return false;
    },
    isLanguageValid(language) {
      let valid = false;
      for (const lang in ALL_LANGUAGES) {
        if (ALL_LANGUAGES[lang].value === language) {
          valid = true;
        }
      }

      return valid;
    },
    isLocalNotificationWebSocketDisabled() {
      if (IS_LOCAL_TEST || typeof window === 'undefined') {
        return true;
      }

      return ['localhost', '127.0.0.1', '::1'].includes(
        window.location.hostname
      );
    },
    isNotificationWebSocketActive() {
      return (
        this.webSocket &&
        [WebSocket.CONNECTING, WebSocket.OPEN].includes(
          this.webSocket.readyState
        )
      );
    },
    closeNotificationWebSocket() {
      if (!this.webSocket) {
        this.notificationWebSocketUrl = null;
        return;
      }

      this.webSocket.onclose = null;
      this.webSocket.close();
      this.webSocket = null;
      this.notificationWebSocketUrl = null;
    },
    buildNotificationWebSocketUrl() {
      const params = new URLSearchParams({
        token: this.accessToken,
        company: this.company,
      });

      return `${NOTIFICATION_WEBSOCKET_URL}/notify?${params.toString()}`;
    },
    busListener() {
      if (this.isLocalNotificationWebSocketDisabled()) {
        this.closeNotificationWebSocket();
        return;
      }

      if (!this.isUserLoggedIn || !this.enabled) {
        this.closeNotificationWebSocket();
        return;
      }

      const nextWebSocketUrl = this.buildNotificationWebSocketUrl();

      if (
        this.isNotificationWebSocketActive() &&
        this.notificationWebSocketUrl === nextWebSocketUrl
      ) {
        return;
      }

      this.closeNotificationWebSocket();
      this.notificationWebSocketUrl = nextWebSocketUrl;
      this.webSocket = new WebSocket(nextWebSocketUrl);

      this.webSocket.onmessage = (event) => {
        this.checkReports(JSON.parse(event.data));
      };
      this.webSocket.onclose = () => {
        this.webSocket = null;
        this.notificationWebSocketUrl = null;
      };
      // Limpiar usuarios al cambiar de compañía
      this.$store.commit('company/SET_USERS', []);
    },
    getQueryParam(queryParam) {
      const params = new Proxy(
        new URLSearchParams(window.location.search),
        {
          get: (searchParams, prop) => searchParams.get(prop),
        }
      );
      return params[queryParam];
    },
    checkReports(reports) {
      const reportsNotSeen = reports.some((report) => {
        return (
          !report.been_seen && report.company_code === this.company
        );
      });

      if (reportsNotSeen) {
        this.shouldNotify = true;
        this.setPendingNotifications(true);
      } else {
        this.shouldNotify = false;
        this.setPendingNotifications(false);
      }

      if (this.shouldNotify) {
        this.$notifyDX(
          {
            message: this.$t('pendingNotifications'),
            width: 350,
          },
          'warning',
          4000
        );
      }
    },
    setMenu() {
      if (this.items.length === 0) {
        return;
      }

      this.setAddress(this.items[0].addressCode);
      this.setCompany(this.items[0].addressCompany);
      this.setAddressName(this.items[0].name);
      this.setCompanyName(this.items[0].companyName);
      this.setCurrency(this.items[0].currency || null);
      this.setMenuAddress();

      this.items.forEach((contact) => {
        if (contact.id === this.items[0].id) {
          this.setAddresses(contact.itemsData);
        }
      });
    },
    translateLanguage(value) {
      let key = '';
      for (const lang in ALL_LANGUAGES) {
        if (ALL_LANGUAGES[lang].key === value) {
          key = ALL_LANGUAGES[lang].value;
        }
      }

      return key;
    },
    normalizeLanguage(value) {
      const normalizedValue = String(value || '').trim();
      if (!normalizedValue) return '';

      const byValue = ALL_LANGUAGES.find(
        (lang) => lang.value === normalizedValue.toLowerCase()
      );
      if (byValue) return byValue.value;

      const byKey = ALL_LANGUAGES.find(
        (lang) => lang.key === normalizedValue.toUpperCase()
      );
      return byKey?.value || '';
    },
    getNavigatorLanguage() {
      const navigatorLanguage = navigator.language
        .substring(0, 2)
        .toLowerCase();

      return this.isLanguageValid(navigatorLanguage)
        ? navigatorLanguage
        : defaultLocale;
    },
    getPreferredLanguage(fallbackLanguage) {
      return (
        this.normalizeLanguage(this.languageInterface) ||
        this.normalizeLanguage(this.contactInfo?.language) ||
        this.normalizeLanguage(fallbackLanguage) ||
        this.getNavigatorLanguage()
      );
    },
    setPreferedLanguage() {
      if (this.isUserLoggedIn) {
        if (this.enabled) {
          const lang = this.getPreferredLanguage(
            this.userProfile.language
          );

          locale(`${lang}-${lang.toUpperCase()}`);
          loadMessages(this.langsDx[`${lang}Messages`]);

          setTimeout(() => {
            this.$i18n.i18next.changeLanguage(lang);
            this.updateLanguageInterface(lang);
          }, 0);
        } else {
          const lang = this.getPreferredLanguage(
            this.authenticatedUser.language_code
          );

          locale(`${lang}-${lang.toUpperCase()}`);
          loadMessages(this.langsDx[`${lang}Messages`]);

          setTimeout(() => {
            this.$i18n.i18next.changeLanguage(lang);
            this.updateLanguageInterface(lang);
          }, 0);
        }
      } else {
        setTimeout(() => {
          this.$i18n.i18next.changeLanguage(
            this.getNavigatorLanguage()
          );
        }, 0);
      }
    },
    createMenuStructure() {
      if (
        this.authenticatedUser.email !== undefined &&
        this.authenticatedUser.email.toString().includes('@')
      ) {
        this.setEnabled(true);
        const { contacts } = this.authenticatedUser;

        const items = [];
        contacts.forEach((cntact, index) => {
          return cntact.companies.forEach((company) => {
            items.push(
              ...company.addresses.map((address) => {
                return {
                  // Estas propiedades proceden de /user/authorization y se
                  // copian al modelo del menú junto con el resto de la empresa.
                  id: `${company.id}_${address.code}`,
                  name: address.address,
                  companyId: company.id,
                  addressCompany: company.code,
                  companyName: company.name,
                  category: company.category,
                  CategoriaABC: company.CategoriaABC ?? null,
                  addressCode: address.code,
                  currency: company.currency,
                  desc_comuna: address.desc_comuna,
                  agent: company.agent,
                  code_agent: company.code_agent,
                  agent_email: company.agent_email,
                  contactIndex: index,
                  itemsData: company.addresses.map((addr) => {
                    return {
                      // Se conserva la misma información para cada dirección
                      // accesible del contacto seleccionado.
                      id: `${company.id}_${addr.code}`,
                      name: addr.address,
                      companyId: company.id,
                      addressCompany: company.code,
                      country: company.country,
                      city: addr.city,
                      province: addr.province,
                      language: company.language,
                      category: company.category,
                      CategoriaABC: company.CategoriaABC ?? null,
                      currency: company.currency,
                      identification_number:
                        company.identification_number,
                      fax: addr.fax,
                      agent: company.agent,
                      code_agent: company.code_agent,
                      agent_email: company.agent_email,
                      desc_comuna: addr.desc_comuna,
                      phone: addr.phone,
                      companyName: company.name,
                      addressCode: addr.code,
                    };
                  }),
                };
              })
            );
          });
        });

        this.setItems(items);
      } else {
        this.setEnabled(false);

        const { headquarters } = this.authenticatedUser;

        // head code => address
        // code => company

        const items = [];

        headquarters.forEach((headquarter) => {
          items.push(
            ...headquarter.companies.map((company) => {
              return {
                addressCode: headquarter.headquarter_code,
                addressName: headquarter.headquarter_name,
                name: company.name,
                companyName: company.name,
                companyCode: company.code,
                category: company.category,
                CategoriaABC: company.CategoriaABC ?? null,
                currency:
                  company.currency ||
                  headquarter.headquarter_currency ||
                  null,
              };
            })
          );
        });

        this.setItems(items);
      }
    },
    realoadPage() {
      // page reloaded
      window.location.reload();
    },
    ...mapActions('contact', [
      'setEnabled',
      'setAddresses',
      'setAddressName',
      'setAddress',
      'setCompany',
      'setCompanyName',
      'setCurrency',
      'setContactIndex',
    ]),
    ...mapActions('clientMenu', ['setItems']),
    ...mapActions('notifications', [
      'getReportsNoSet',
      'setPendingNotifications',
    ]),
    ...mapActions('clientMenu', {
      setMenuAddress: 'setAddress',
    }),
    ...mapActions('user', [
      'setShowTokenPage',
      'logOut',
      'setIsUserLoggedIn',
      'setWebSocket',
      'destroyWebSocket',
      'updateLanguageInterface',
    ]),
    ...mapActions('videoPeriodModule', [
      'resetCounter',
      'setActiveUserEmail',
    ]),
    ...mapActions('filter', [
      'setCurrentFilter',
      'setCurrentSampleId',
    ]),
    ...mapActions('samples', [
      'getCurrentSampleByCode',
      'setReportSampleCode',
      'setSampleFetchedFromEtl',
      'setLastRouteHome',
      'setLastRouteGeotoolboxSamples',
      'setLastRouteIssuedInvoicesList',
    ]),
    ...mapActions('foodSamples', ['setIsNoRp', 'setEuropeanChains']),
    ...mapActions('foodDetailsFilter', ['setSelectedLimits']),
    ...mapActions('breadcrumb', ['pushRoute', 'clearRoutes']),
    ...mapActions('PowerBiModules', ['fetchCountriesAvailables']),
  },
};
</script>
<style lang="scss" scoped>
.panel {
  min-width: var(--f7-panel-left-collapsed-width);
  overflow-x: hidden;
  overflow-y: auto;
  display: flex;
  flex-direction: column;
  min-height: 99%;
}

.modal-backdrop {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.4); /* O el color que desees */
  z-index: 9998; /* Un valor menor que el z-index del panel para que esté debajo */
}

.hash-preloader-overlay {
  position: fixed;
  inset: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 10002;
  pointer-events: none;
}

.session-preloader-overlay {
  position: fixed;
  inset: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 10003;
  background: var(--Neutral-10, #edf3fa);
  pointer-events: all;
}

.hash-preloader-card {
  min-width: 180px;
  min-height: 88px;
  border-radius: 10px;
  background: #fff;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.12);
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  padding: 14px 18px;
}

.hash-preloader-text {
  font-size: 14px;
  color: #4b5563;
}

:deep(.legal-documents-auth-footer) {
  width: 100%;
  box-sizing: border-box;
  margin: 18px 0 4px;
  padding: 3px;
  display: flex;
  justify-content: flex-start;
}

:deep(.legal-documents-auth-footer-host) {
  position: relative;
}

:deep(.legal-documents-auth-footer--bottom) {
  position: absolute;
  left: 60px;
  right: 60px;
  bottom: 10px;
  width: auto;
  margin-top: 0;
}

:deep(.legal-documents-auth-footer__link) {
  color: #8a8693;
  font-size: 12px;
  line-height: 1.2;
  text-decoration: none;
}

:deep(.legal-documents-auth-footer__link:hover),
:deep(.legal-documents-auth-footer__link:focus-visible) {
  color: var(--his-berenjena, #2f4155);
  text-decoration: underline;
}
</style>
